@if (missingActions() && !showForm()) {
  <!-- Dizer porque é que não há botão: o seguimento acompanha as ações (revisão de 2026-10-15). -->
  <p class="text-muted small mb-3">
    <i class="fe fe-info me-1"></i>
    O seguimento acompanha as ações do tratamento — acrescente-as primeiro, na secção Tratamento.
  </p>
}

@if (canStart() && !showForm()) {
  <div class="d-flex justify-content-end mb-3">
    <button type="button" class="btn btn-sm btn-white" (click)="openForm()">
      <i class="fe fe-plus me-1"></i> Registar seguimento
    </button>
  </div>
}

@if (showForm()) {
  <div class="border rounded p-3 mb-3">
    <div class="row g-3">
      <div class="col-md-4">
        <label class="form-label">Data</label>
        <app-date-picker [(ngModel)]="newDate" />
      </div>
      <div class="col-md-8">
        <label class="form-label">Descrição <span class="text-danger">*</span></label>
        <!-- Textos de ajuda da revisão de 2026-10-19. -->
        <textarea class="form-control" rows="2" [(ngModel)]="newDescription"
                  placeholder="Registar as atividades realizadas, os resultados obtidos e a evolução das ações"></textarea>
      </div>
      <div class="col-12">
        <label class="form-label">Notas</label>
        <!-- Área de texto: numa linha só, uma nota grande deixava de se ver enquanto se escrevia
             (revisão de 2026-10-12). -->
        <textarea class="form-control" rows="3" [(ngModel)]="newNotes"
                  placeholder="Identificar dificuldades, decisões, aspetos pendentes ou próximos passos"></textarea>
      </div>
      <!-- O que a entrada faz, para lá de ficar escrita. Fica no fim do formulário, depois do
           que se escreve (documento de 2026-10-03). -->
      <div class="col-12"><hr class="my-1" /></div>
      <!-- Várias ações por entrada (documento de 2026-10-08): uma ronda de seguimento toca
           muitas vezes em mais do que uma, e antes isso obrigava a repetir a entrada. -->
      <div class="col-md-6">
        <label class="form-label">Associar ações</label>
        @if (actions().length) {
          <div class="form-check">
            <input class="form-check-input" type="checkbox" id="followUpAllActions"
                   [checked]="allActionsSelected()"
                   (change)="toggleAllActions($any($event.target).checked)" />
            <label class="form-check-label fw-bold" for="followUpAllActions">Todas</label>
          </div>
          @for (action of actions(); track action.id) {
            <div class="form-check">
              <input class="form-check-input" type="checkbox" [id]="'followUpAction' + action.id"
                     [checked]="isActionSelected(action.id)"
                     (change)="toggleAction(action.id, $any($event.target).checked)" />
              <label class="form-check-label" [for]="'followUpAction' + action.id">
                #{{ action.sequence }} — {{ action.description }}
              </label>
            </div>
          }
          @if (!newActionIds().length) {
            <small class="text-muted d-block">— nenhuma em particular</small>
          }
        } @else {
          <small class="text-muted d-block">Esta ocorrência ainda não tem ações no tratamento.</small>
        }
      </div>
      <div class="col-md-6">
        <label class="form-label">Partilhar com</label>
        <select class="form-select" [(ngModel)]="newSharedWithUserId">
          <option [ngValue]="null">— ninguém</option>
          @for (member of teamMembers(); track member.id) {
            <option [ngValue]="member.id">{{ member.name }}</option>
          }
        </select>
      </div>
      <div class="col-12">
        <div class="d-flex align-items-center gap-2 flex-wrap">
          <div class="form-check mb-0">
            <!-- Enviado daqui, o pisco fica preso: o e-mail saiu mesmo (revisão de 2026-10-19). -->
            <input class="form-check-input" type="checkbox" id="followUpEmailSent"
                   [(ngModel)]="newEmailSent" [disabled]="emailSentNow()" />
            <label class="form-check-label" for="followUpEmailSent">Foi enviado um e-mail</label>
          </div>
          <!-- Enviar daqui: o pisco passa a estar marcado por ter acontecido, e a mensagem fica
               nas Comunicações da ocorrência (documento de 2026-10-08). -->
          @if (!emailForm()) {
            <button type="button" class="btn btn-sm btn-white" (click)="openEmail()">
              <i class="fe fe-mail me-1"></i> Enviar e-mail
            </button>
          }
        </div>
        @if (emailSentNow()) {
          <small class="text-warning d-block mb-1">
            <i class="fe fe-alert-circle me-1"></i>
            O e-mail já saiu e está nas Comunicações — descreva o que foi feito e registe a entrada.
          </small>
        }
        @if (emailForm()) {
          <div class="border rounded p-3 mt-2 mb-2">
            <div class="row g-2">
              <div class="col-md-6">
                <label class="form-label">Para</label>
                <input class="form-control" type="email" [(ngModel)]="emailTo"
                       placeholder="endereco@exemplo.pt" />
              </div>
              <div class="col-md-6">
                <label class="form-label">Assunto</label>
                <input class="form-control" [(ngModel)]="emailSubject" placeholder="Assunto" />
              </div>
              <div class="col-12">
                <label class="form-label">Mensagem</label>
                <textarea class="form-control" rows="3" [(ngModel)]="emailBody"></textarea>
              </div>
            </div>
            <div class="d-flex justify-content-end gap-2 mt-2">
              <button type="button" class="btn btn-sm btn-white" (click)="cancelEmail()">Cancelar</button>
              <button type="button" class="btn btn-sm btn-primary" (click)="sendEmail()"
                      [disabled]="sendingEmail()">
                {{ sendingEmail() ? 'A enviar…' : 'Enviar' }}
              </button>
            </div>
          </div>
        }
        <div class="form-check" [class.opacity-50]="!canTransfer()">
          <input class="form-check-input" type="checkbox" id="followUpTransfer"
                 [(ngModel)]="newTransferResponsibility"
                 [disabled]="!canTransfer()" />
          <label class="form-check-label" for="followUpTransfer">
            Alterar o responsável pela implementação
            <span class="text-muted d-block small">
              @if (newActionIds().length) {
                Passa a responsável das ações associadas. A troca fica registada nas notas.
              } @else {
                A troca fica registada nas notas.
              }
            </span>
          </label>
        </div>
        <!-- Também na edição: quem desiste da ocorrência derivada volta a esta linha e não
             tinha por onde tentar outra vez. Só desaparece depois de a derivada existir. -->
        @if (!editingHasDerived()) {
          <div class="form-check">
            <input class="form-check-input" type="checkbox" id="followUpTransferOccurrence"
                   [(ngModel)]="newTransferToOccurrence" />
            <label class="form-check-label" for="followUpTransferOccurrence">
              Criar ocorrência associada
              <span class="text-muted d-block small">
                Ao registar, abre o formulário da ocorrência associada, já ligado a esta entrada.
              </span>
            </label>
          </div>
        }
      </div>
      <!-- A evidência que a entrada produziu anexa-se daqui e fica na secção Evidências, associada
           a esta entrada (revisão de 2026-10-13). Só os ficheiros: a data, a descrição e as notas
           são as da entrada, escritas acima (revisão de 2026-10-19). -->
      <div class="col-12">
        @for (draft of evidenceDrafts(); track $index) {
          <div class="d-flex align-items-center gap-2 small mb-1">
            <i class="fe fe-paperclip text-warning"></i>
            <span class="text-truncate">{{ fileNames(draft) }}</span>
            <button type="button" class="btn btn-sm btn-link text-danger p-0 ms-1"
                    (click)="removeEvidenceDraft($index)" title="Tirar esta evidência">
              <i class="fe fe-x"></i>
            </button>
          </div>
        }
        @if (evidenceDraft(); as draft) {
          <div class="border rounded p-3 mt-1">
            <h6 class="text-uppercase text-muted mb-3"><i class="fe fe-paperclip me-1"></i> Evidência desta entrada</h6>
            <app-evidence-draft [draft]="draft" [filesOnly]="true" (draftChange)="evidenceDraft.set($event)" />
            <small class="text-muted d-block mt-2">Fica com a data, a descrição e as notas desta entrada.</small>
            <div class="d-flex justify-content-end gap-2 mt-3">
              <button type="button" class="btn btn-sm btn-white" (click)="cancelEvidenceDraft()">Cancelar</button>
              <button type="button" class="btn btn-sm btn-primary" (click)="keepEvidenceDraft()">Anexar</button>
            </div>
          </div>
        } @else {
          <button type="button" class="btn btn-sm btn-white" (click)="openEvidenceDraft()">
            <i class="fe fe-plus me-1"></i> Registar evidência
          </button>
          <span class="small text-muted ms-2">Fica na secção Evidências, associada a esta entrada.</span>
        }
      </div>
    </div>
    @if (error()) { <div class="alert alert-danger small py-2 mt-3 mb-0">{{ error() }}</div> }
    <div class="d-flex justify-content-end gap-2 mt-3">
      <button type="button" class="btn btn-sm btn-white" (click)="cancelForm()"
              [disabled]="emailSentNow()"
              [title]="emailSentNow() ? 'O e-mail já saiu: registe a entrada' : ''">Cancelar</button>
      <button type="button" class="btn btn-sm btn-primary" (click)="add()" [disabled]="saving()">
        {{ saving() ? 'A guardar…' : (editingId() === null ? 'Registar' : 'Guardar') }}
      </button>
    </div>
  </div>
}

@if (entries().length === 0) {
  <p class="text-muted mb-0">
    @if (canWrite() && !canRegister()) {
      <!-- Dizer porque é que não há botão. Sem isto parecia que a secção estava avariada. -->
      O seguimento começa quando a ocorrência passa a tratamento — é o registo do que se vai
      fazendo para a resolver.
    } @else {
      Sem seguimento registado. Cada entrada fica datada e pode assinalar o envio de e-mail ou
      dar origem a outra ocorrência.
    }
  </p>
} @else {
  <div class="table-responsive">
    <table class="table table-sm table-nowrap mb-0">
      <thead>
        <tr>
          <th>Data</th>
          <th>Ação</th>
          <th class="text-wrap">Descrição</th>
          <th class="text-center">E-mail</th>
          <th>Ocorrência associada</th>
          <th>Partilhada</th>
          <th class="text-wrap">Notas</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        @for (entry of entries(); track entry.id) {
          <tr>
            <td>{{ entry.entryDate | date: 'dd/MM/yyyy' }}</td>
            <td>
              @if (entry.actionSequences.length) {
                @for (sequence of entry.actionSequences; track sequence) {
                  <span class="badge bg-secondary-soft me-1">#{{ sequence }}</span>
                }
              } @else { <span class="text-muted">—</span> }
            </td>
            <td class="text-wrap">
              {{ entry.description }}
              <span class="small text-muted d-block">{{ entry.createdByName }}</span>
            </td>
            <td class="text-center">
              @if (entry.emailSent) {
                <i class="fe fe-check text-success" title="E-mail enviado"></i>
                @if (entry.emailSentAt) {
                  <span class="small text-muted d-block">{{ entry.emailSentAt | date: 'dd/MM/yyyy' }}</span>
                }
              } @else { <span class="text-muted">—</span> }
            </td>
            <!-- Só o que aconteceu: a tabela é para perceber o que foi feito, e abrir uma
                 ocorrência faz-se ao registar a entrada (documento de 2026-10-03). -->
            <td>
              @if (entry.createdOccurrenceId) {
                <i class="fe fe-link text-info me-1" title="Ocorrência associada criada a partir desta entrada"></i>
                <a [routerLink]="[occurrencesPath(), entry.createdOccurrenceId]">{{ entry.createdOccurrenceCode }}</a>
              } @else { <span class="text-muted">—</span> }
            </td>
            <td>
              @if (entry.sharedWithUserName) {
                <i class="fe fe-corner-up-right text-primary me-1" title="Partilhada"></i>
                {{ entry.sharedWithUserName }}
              } @else { <span class="text-muted">—</span> }
            </td>
            <!-- A evidência que a entrada trouxe vive na secção Evidências; aqui diz-se só que existe,
                 na coluna das notas (revisão de 2026-10-19 — estava debaixo da descrição). -->
            <td class="text-wrap small text-muted">
              @if (entry.notes) { <span style="white-space: pre-wrap;">{{ entry.notes }}</span> }
              @if (entry.evidenceCount) {
                <span class="text-warning d-block">
                  <i class="fe fe-paperclip me-1"></i>{{ entry.evidenceCount }} {{ entry.evidenceCount === 1 ? 'evidência' : 'evidências' }}
                </span>
              }
              @if (!entry.notes && !entry.evidenceCount) { — }
            </td>
            <td class="text-end">
              @if (canWrite()) {
                <button type="button" class="btn btn-sm btn-white me-1" (click)="openEdit(entry)" title="Editar entrada">
                  <i class="fe fe-edit-2"></i>
                </button>
                <button type="button" class="btn btn-sm btn-white" (click)="askRemove(entry)" title="Remover entrada">
                  <i class="fe fe-trash-2"></i>
                </button>
              }
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
}

<!-- Dois passos, e dá para voltar atrás no segundo: "só depois de todas as questões
     respondidas é que executa a ação completa" (documento de 2026-10-08). -->
@if (pendingRemoval(); as pending) {
  @if (removalStep() === 'confirmar') {
    <app-confirm-dialog
      title="Remover entrada de seguimento"
      [message]="pending.createdOccurrenceId
        ? 'Foi criada uma ocorrência a partir deste seguimento. Confirma a eliminação?'
        : 'A entrada deixa de constar no histórico do seguimento.'"
      confirmLabel="Remover"
      [danger]="true"
      (confirm)="confirmRemove()"
      (cancel)="cancelRemove()"
    />
  } @else {
    <div class="modal d-block" tabindex="-1" role="dialog" style="background: rgba(0,0,0,.5);">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Ligação à ocorrência criada</h5>
          </div>
          <div class="modal-body">
            <p class="mb-0">
              Pretende manter ou remover a ligação a
              <strong>{{ pending.createdOccurrenceCode || 'ocorrência criada' }}</strong>?
            </p>
            <p class="small text-muted mb-0 mt-2">
              A ocorrência criada não é eliminada. Remover a ligação deixa-a a existir por si.
            </p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-white" (click)="backToConfirm()">Voltar</button>
            <button type="button" class="btn btn-white" (click)="removeDroppingLink()">Remover a ligação</button>
            <button type="button" class="btn btn-primary" (click)="removeKeepingLink()">Manter a ligação</button>
          </div>
        </div>
      </div>
    </div>
  }
}
